import { useCreateExpense } from 'api/expenses/use-create-expense.ts';
import type { TCreateExpenseReq } from 'api/swagger';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { formatDate } from 'shared/utils/time/format-date';
import { ECurrency } from 'types/currencies';
import { FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { ExpenseForm } from 'components/expenses/expense-form';
import type { IExpenseFormFields } from 'components/expenses/expense-form';
import type { IExpenseCreateProps } from './types';

export const ExpenseCreateComponent = (props: IExpenseCreateProps) => {
  const { orderId, tripId, whTaskId, initialValues, isLoadingData = false, partnerDisabled = false } = props;

  const { mutateAsync: createExpense, isLoading } = useCreateExpense();

  const onFinish = async (values: IExpenseFormFields) => {
    const apiVariables: TCreateExpenseReq = {
      clientNumber: values.clientNumber,
      typeId: values.typeId,
      price: values.price,
      currency: values.currency,
      endDate: formatDate(values.endDate),
      orderId,
      tripId,
      warehouseTaskId: whTaskId,
      partnerId: values.partner?.value,
      contactId: values.contact?.value,
    };

    await createExpense(apiVariables);
  };

  return (
    <FormDrawerWithButton
      formComponent={ExpenseForm}
      formProps={{ initialValues: { currency: ECurrency.EUR, ...initialValues }, partnerDisabled }}
      title='Create expense'
      buttonLabel='Add expense'
      isLoading={isLoading}
      buttonDisabled={isLoadingData}
      onFinish={onFinish}
    />
  );
};

export const ExpenseCreate = withRoleGuard<IExpenseCreateProps>(ExpenseCreateComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
